/**
 * @typedef {Object} Impression
 * @property {string} id
 * @property {string} name
 * @property {string} price
 * @property {string} brand
 * @property {string} category
 * @property {number} position
 */

/**
 * @param {string} list
 * @param {Impression} product
 * @returns {*}
 */
export function createProductClick(list, product) {
    return Promise.resolve({
        'event': 'productClick',
        'ecommerce': {
            'click': {
                'actionField': { 'list': list },
                'products': [ product ]
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Product Clicks',
            'gtm-ee-event-non-interaction': 'False',
        }
    });
}
